// REACT
import React, { Component } from 'react';

// REDUX
import { connect } from 'react-redux';
import * as actions from 'actions';

import { utils } from '../../../constants';

const { toWeekDayName, toDateString } = utils;
const monthNames = [
    'Jan',
    'Feb',
    'Mar',
    'Apr',
    'May',
    'Jun',
    'Jul',
    'Aug',
    'Sep',
    'Oct',
    'Nov',
    'Dec',
];

import moment from 'moment-timezone';
class Timeslots extends React.Component {
    render() {
        const { styles, screenWidth, matrix, calendarWeek } = this.props;

        // console.table(matrix);
        // console.dir(matrix);
        console.log('matrix', matrix);
        // console.log(calendarWeek.matrix);

        return (
            <div style={styles.calendarContentContainer}>
                {matrix &&
                    matrix.map((day, i) => {
                        return (
                            <div key={i} style={styles.dayContainer}>
                                <div style={styles.dayHeader}>
                                    <div style={styles.dateText}>
                                        {screenWidth < 500
                                            ? monthNames[
                                                  parseInt(
                                                      day.key.split('-')[1],
                                                      10,
                                                  ) - 1
                                              ].charAt(0) +
                                              ' ' +
                                              day.key.split('-')[2]
                                            : screenWidth < 700
                                            ? monthNames[
                                                  parseInt(
                                                      day.key.split('-')[1],
                                                      10,
                                                  ) - 1
                                              ] +
                                              ' ' +
                                              day.key.split('-')[2]
                                            : day.key}
                                    </div>
                                    <div style={styles.dateTitleDivider} />
                                    <div style={styles.dayText}>
                                        {screenWidth < 700
                                            ? toWeekDayName(day.key).charAt(0)
                                            : toWeekDayName(day.key)}
                                    </div>
                                </div>
                                {day.value &&
                                    day.value.map((time, index) => {
                                        return (
                                            <div
                                                style={styles.slotStyle}
                                                key={index}
                                            >
                                                <button
                                                    style={styles.buttonStyle}
                                                    onClick={() =>
                                                        this.props.handleSlotSelection(
                                                            time,
                                                            day.key,
                                                            i,
                                                        )
                                                    }
                                                >
                                                    {this.props.timeFormat ===
                                                        12 &&
                                                        moment(
                                                            time,
                                                            'HH:mm:ss',
                                                        ).format('h:mm a')}
                                                    {this.props.timeFormat ===
                                                        24 && time.slice(0, -3)}
                                                </button>
                                            </div>
                                        );
                                    })}
                            </div>
                        );
                    })}
            </div>
        );
    }
}

const mapStateToProps = ({ time }) => {
    return {
        timeFormat: time.format,
    };
};

export default connect(
    mapStateToProps,
    actions,
)(Timeslots);



// WEBPACK FOOTER //
// ./src/js/components/Calendar/Timeslots/Timeslots.jsx